import {
  DC_Repositories_Base_Enumerations_BusinessUnit,
  DC_Repositories_Base_Enumerations_Label,
  RequestModels_Financials_GasHeat_GasHeatRegionConsumptionModel,
  ResponseModels_Financials_GasHeat_GasHeatYearCostModel,
} from '@monorepo-types/dc';

import { request } from '../client';
import type { ApiRequestConfig } from '../client/types';

type CalculateGasHeatYearCost = {
  businessUnit: DC_Repositories_Base_Enumerations_BusinessUnit;
  label: DC_Repositories_Base_Enumerations_Label;
  requestBody: RequestModels_Financials_GasHeat_GasHeatRegionConsumptionModel;
};
/**
 * Returns the yearcost of Gas and warmth based on the consumption
 *
 * @returns ResponseModels_Financials_GasHeat_GasHeatYearCostModel Success
 */
export function calculateGasHeatYearCost(
  { businessUnit, label, requestBody }: CalculateGasHeatYearCost,
  requestConfig: ApiRequestConfig = {},
): Promise<ResponseModels_Financials_GasHeat_GasHeatYearCostModel> {
  return request(
    {
      method: 'POST',
      path: `/dxpweb/public/${businessUnit}/${label}/gasheat/yearcost`,
      body: requestBody,
      errors: { 400: 'Bad Request' },
    },
    requestConfig,
  );
}
